if (!customElements.get('product-size-guide')) {
  customElements.define(
    'product-size-guide',
    class ProductSizeGuide extends window.BAO.CustomElement {
      constructor() {
        super()
        this.els.trigger.element.addEventListener('click', this.onClick)
      }

      onClick() {

        const trigger = document.querySelector(
          `[data-open-fit-guide="true"]`,
        )
        if (trigger) {
          document.querySelector('button[data-product-size-tabs-name="fitting-guide"]').click()
        }

        window.scrollTo({
          top:
            window.BAO.utils.getOffsetTop(
              window.BAO.utils.getElement(
                `[data-external-el="product-size-guide.target"]`,
              ),
            ) - 30,
          left: 0,
          behavior: 'smooth',
        })
      }
    },
  )
}
